// extracted by mini-css-extract-plugin
module.exports = {"breakBundle":"break-bundle_breakBundle__VNUbW"};